//  export const host = "http://localhost:4001";
export const host = "https://api.creedinfotech.com";

export const loginRoute = host+'/signin';
export const logOut = host+'/admin/sign-out';
export const userAuthentication = host+'/user/authentication';

// export const getUserList = host+'/admin/user/list';
export const addResister = host+'/register/add';
export const getAllUserList = host+'/user/list';

export const jobPostingsUserList = host+'/api/job-postings/users';
export const getOneUserById = host+'/getoneuserbyid';
export const UploadUserImage = host+'/upload_user_image';
export const userLogout = host+'/admin/sign-out';
export const formApprove = host+'/approve';
export const GetBookingDataByUserId = host+'/get/registerdata';
export const GetOneBookingDataById = host+'/register/get';
export const EditBookingDataById = host+'/register/edit';
export const DeleteBookingDataById = host+'/register/delete';
export const GetUserRoles = host+'/role';
export const getpermitions = host+'/getpermissions';
export const addUser = host+'/useradd';
export const getManagerData= host+'/managerData';
export const getTlData= host+'/teamleaderData';
export const getUserDataByToken = host+'/getuserinfo';

export const getCatagories = host+'/getallcategoriesbyproject';
export const getProjects = host+'/getallprojects';

export const addBlogs = host+'/creedblog';
export const getAllBlog = host+'/blog/fetch';
export const GetBlogsDataById = host+'/blog/getSingleAdminBlog/';
export const UpdateBlogData = host+'/blog/blog_update';
export const DeleteBlogData = host+'/blog/blog_delete';
export const UploadBlogBodyImage= host+'/bodyimageupload';
export const UploadFeatureImageUrl= host+'/upload_feature_image';

//  job api
export const getAllJob = host+'/getjob';
export const postJob = host+'/jobcreate';
export const updateJob = host+'/updatejob';
export const getjobdatabyid = host+'/getjobbyid';
export const UploadJobIcon = host+'/api/jobiconupload';

export const GetJobDataById = host+'/job/getSingleAdminJob/';
export const DeleteJobData = host+'/job/job_delete';

// internal hiring / job postings
export const jobPostingsApi = host + '/api/job-postings';
export const jobLeadsApi = host + '/api/job-leads';
export const jobCategoriesApi = host + '/api/job-categories';
export const jobTagsApi = host + '/api/job-tags';
export const jobLeadResumeUploadApi = host + '/api/job-lead/resume';
export const jobLeadCoverLetterUploadApi = host + '/api/job-lead/cover-letter';
export const jobPostingFeaturedImageUploadApi = host + '/api/job-posting/featured-image';

// Attendance & Leave management
export const attendancePunchHookApi = host + '/api/attendance/punch-hook';
export const attendanceApi = host + '/api/attendance';
export const attendanceWeeklyTimesheetApi = host + '/api/attendance/timesheet/week';
export const leaveApi = host + '/api/leave';
export const wfhApi = host + '/api/wfh';
export const regularizationApi = host + '/api/regularization';
export const penaltyApi = host + '/api/penalty';

// Employees (for attendance selection)
export const employeesApi = host + '/api/employees';

// Payroll & Salary
export const payrollEmployeeSalariesApi = host + '/api/payroll/employee-salaries';
export const payrollItemsApi = host + '/api/payroll/items';
export const payrollEmployeeIncentivesBaseApi = host + '/api/payroll/employee';
export const payrollPayslipsApi = host + '/api/payroll/payslips';
export const payrollRecurringIncentivesApi = host + '/api/payroll/incentives/recurring';
export const payrollMonthlyIncentivesApi = host + '/api/payroll/incentives/monthly';
export const payrollEmployeePayrollItemApi = host + '/api/payroll/employee/payroll-items';

// servay api's
export const  singleSurveyDataById = host+'/api/singlesurvaydata';
export const  surveyDataAllPercentageAndCount = host+'/api/getalloveraverage';
export const  surveyquestionsdata = host+'/api/geteveryquestionsanswerpercentage';
export const  surveydatabyuser = host+'/api/getalldatabyuser';

// announcement api's
export const getAllAnnouncements = host+'/api/announcements';
export const getAnnouncementById = host+'/api/announcement/';
export const getAnnouncementDetails = host+'/api/announcement/';
export const createAnnouncement = host+'/api/announcement';
export const updateAnnouncement = host+'/api/announcement/';
export const deleteAnnouncement = host+'/api/announcement/';
export const approveAnnouncement = host+'/api/announcement/';
export const rejectAnnouncement = host+'/api/announcement/';
export const getPendingAnnouncements = host+'/api/announcements/pending';